// extracted by mini-css-extract-plugin
export default {"truncate":"ContributorHeader_truncate__3w3Mf"};